import {
  EFFECT_DEFAULT_VALUE,
  EFFECT_VALUE_MAX,
  EFFECT_VALUE_MIN,
  EFFECT_VALUE_MIN_ZERO,
  HIGHLIGHT_SENSITIVITY_DEFAULT,
} from 'constants/params';
import { ConfigFlags as FileConfigFlags } from 'services/file.service';
import { ConfigFlags as ClipConfigFlags } from 'services/clip.service';

export const SPEED_SLOW = 0.5;
export const SPEED_FAST = 2;

const SLIDER_PARAMS_BASE = {
  min: EFFECT_VALUE_MIN,
  max: EFFECT_VALUE_MAX,
  default: EFFECT_DEFAULT_VALUE,
  step: 0.1,
};

const SLIDER_PARAMS_VOLUME = {
  min: EFFECT_VALUE_MIN_ZERO,
  max: EFFECT_VALUE_MAX,
  default: EFFECT_VALUE_MAX,
  step: 1,
};

const SLIDER_PARAMS_HIGHLIGHT_SENSITIVITY = {
  min: EFFECT_VALUE_MIN_ZERO,
  max: EFFECT_VALUE_MAX,
  default: HIGHLIGHT_SENSITIVITY_DEFAULT,
  step: 1,
};

export const CONFIGS_SLIDERS_FILE = [
  {
    key: FileConfigFlags.brightness,
    label: FileConfigFlags[FileConfigFlags.brightness].toString(),
    params: SLIDER_PARAMS_BASE,
    forImage: true,
  },
  {
    key: FileConfigFlags.contrast,
    label: FileConfigFlags[FileConfigFlags.contrast].toString(),
    params: SLIDER_PARAMS_BASE,
    forImage: true,
  },
  {
    key: FileConfigFlags.volume,
    label: FileConfigFlags[FileConfigFlags.volume].toString(),
    params: SLIDER_PARAMS_VOLUME,
    forImage: false,
  },
  {
    key: FileConfigFlags.highlightSensitivity,
    label: FileConfigFlags[FileConfigFlags.highlightSensitivity].toString(),
    params: SLIDER_PARAMS_HIGHLIGHT_SENSITIVITY,
    forImage: false,
  },
];

export const CONFIGS_SLIDERS_CLIP = [
  {
    key: ClipConfigFlags.brightness,
    label: ClipConfigFlags[ClipConfigFlags.brightness].toString(),
    params: SLIDER_PARAMS_BASE,
    forImage: true,
  },
  {
    key: ClipConfigFlags.contrast,
    label: ClipConfigFlags[ClipConfigFlags.contrast].toString(),
    params: SLIDER_PARAMS_BASE,
    forImage: true,
  },
  {
    key: ClipConfigFlags.volume,
    label: ClipConfigFlags[ClipConfigFlags.volume].toString(),
    params: SLIDER_PARAMS_VOLUME,
    forImage: false,
  },
];
